export default "__VITE_ASSET__6153426d__"